import http from "../../services/http";

export const loginRequest = (data) => {
  return http.post("auth/login", data);
};

export const logoutRequest = () => {
  return http.post("auth/logout");
};

export const registerRequest = (data) => {
  return http.post("auth/register", data);
};

export const usersInfoRequest = () => {
  return http.get("auth/me");
};
